<template>
    <div class="register">
        <!-- @since v2.3.0 为了防止免费用户蹭流量，只有我的 Chrome 浏览器的 Samsung Galaxy S20 Ultra 才会显示；-->
        <div class="reg-button" @click="show" v-if="isShowLoginLabel">登录</div>
        <el-dialog
            title="登录"
            :visible.sync="isShow"
            :before-close="hide"
            :append-to-body="true"
            :modal-append-to-body="true"
            :close-on-click-modal="false"
            center>
            <div align="center" style="width:100%; margin-top: -20px">
                <!-- 这里借鉴了 element-ui form 的做法，使用 display:table 即便是没有内容也会占用空间 -->
                <div align="left" class='global-error' :style="{padding: `0 0 6px ${vform.lableWidth}`}">{{error}}</div>
                <el-form ref="vform" :model="vform" status-icon :rules="rules" :label-width="vform.lableWidth" @validate="formFieldValidated" :disabled="vform.disable">
                    <el-form-item prop="accountname" label="账户名">
                        <el-input type="text" v-model="vform.accountname" autocomplete="off" placeholder="请输入你的邮箱或者用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input type="password" v-model="vform.password" autocomplete="off" show-password></el-input>
                    </el-form-item>
                    <el-form-item align="center">
                        <el-button type="danger" @click="submitForm('vform')">提交</el-button>
                        <el-button @click="resetForm('vform')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="reg-footer" align="left">
                    <!-- trigger register -->
                    <span>还没有账户，</span><el-link type="primary" :underline='false' @click="toRegister">点击</el-link><div class="margin-right-8px">注册</div>
                    <span>|</span>
                    <!-- trigger find password back -->
                    <el-link type="primary" :underline='false' class="margin-left-8px" @click="toFindPassword">点击</el-link><span>找回密码</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {validateAccountName, validatePassword} from "../../../validator";
    import {login} from "../../../data/user";
    import {loadingInstance, errorMessage, successMessage, Styles} from "../../../utils";

    export default {
        name: "Login",
        data() {
            return {
                isShow: false,
                error: null,  // this is the global error；这是整个组件内最大的难点，因为它脱离了了 form field 的验证框架，如何将它纳入是难点。现在采用的方案是捕获表单字段的 validate 事件，清空它。
                vform: {
                    accountname: null,  // username or email
                    password: null,
                    lableWidth: '80px',
                    disable: false
                },
                rules: {
                    accountname: [
                        { required: true, validator: validateAccountName.bind(this), trigger: ['blur', 'change'] }, // 通过 bind 将 this 传入
                    ],
                    // 注意，password 验证的时候，不要使用 blur，否则成功失败标志和查看密码提示标志冲突
                    password: [
                        { required: true, validator: validatePassword.bind(this), trigger: ['change'] } // 通过 bind 将 this 传入
                    ]
                }
            }
        },
        computed: {
            // @since v2.3.0 为了防止免费用户蹭流量，只有我的 Chrome 浏览器的 Samsung Galaxy S20 Ultra 才会显示；
            isShowLoginLabel() {
                return window.navigator.userAgent.indexOf('Linux; Android 10; SM-G981B') > 0;
            }
        },
        methods: {
            show(){
                this.isShow = true;
                Styles.disableBodyScroll();
            },
            hide(){
                this.isShow = false;
                Styles.enableBodyScroll();
            },
            /**
             * 注意，登录的响应消息目前实现得过于完备，主要是想做成一个 Demo 给其他模块模仿使用
             * @param formName
             */
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.vform.disable = true;
                        let loading = loadingInstance();
                        login(this.vform.accountname, this.vform.password).then((r)=>{
                            if(!r.success){
                                console.log('login failed with error', r.error);
                                this.error = r.error;
                            }else{
                                console.log('login success with data returned', r.data);
                                this.$parent.isSignedIn = true;
                                this.hide();
                                successMessage('登录成功，欢迎回来');
                            }
                        }).catch((error)=>{
                            console.error(error);
                            this.error = '网络超时，请稍后重试';
                            errorMessage(error.message);
                        }).finally(()=>{
                            this.vform.disable = false;
                            loading.close();
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.error = null;
            },
            toRegister(){
                this.isShow = false;
                setTimeout(function(){
                    this.$parent.$refs.register.isShow = true;
                }.bind(this), 200);  // 给一个 timeout 的时间，不然转换太快了。
            },
            toFindPassword(){
                this.isShow = false;
                setTimeout(function(){
                    this.$parent.$refs.findPassword.isShow = true;
                }.bind(this), 200);  // 给一个 timeout 的时间，不然转换太快了。
            },
            // 当任意 form field 执行过验证后的回调事件，在这里清空 global error，这样就不用侵入各个表达字段的验证方法了。
            formFieldValidated(){
                this.error = null;
            },
            // @deprecated, 体验很不好，message 最好做简单的提示用。
            showError(){
                this.$message({
                    showClose: true,
                    message: '错了哦，这是一条错误消息',
                    type: 'error',
                    duration: 0,
                    offset: 150
                });
            }
        }
    }
</script>

<style scoped>

    .global-error{
        height: 22px;
        width: 100%;
        display: table;
        color: #F56C6C
    }

    .register .reg-button{
        cursor: pointer
    }

    .register .reg-button:hover{
        color: #CB0101
    }

    .reg-footer{
        display:inline-flex;
        width: 100%;
        line-height: 22px;
    }

    /* 设置 form field 输入成功的图标样式 */
    /deep/ .el-icon-circle-check:before{
        color: #67C23A;
        content: "\E720";
    }

    /deep/ .el-dialog{
        width: 468px;  /* 主页展示的最大宽度的一半 */
    }

    @media (min-width: 800px) and (max-width: 1100px){
        /deep/ .el-dialog{
            width: 50%;
        }
    }

    @media (min-width: 736px) and (max-width: 799px){
        /deep/ .el-dialog{
            width: 60%;
        }
    }

    /* 收集展示尺寸 */
    @media (max-width: 735px){
        /deep/ .el-dialog{
            width: 80%;
        }
    }

    @media (min-width: 320px) and (max-width: 540px){
        /deep/ .el-dialog{
            width: 100%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/user/login/Login.vue